var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"comp-uninstist"},[_c('LazyImg',{staticClass:"uninstist-label",attrs:{"src":_vm.$images.activity_2026_calligraphy_level2.welcome_ask_uninsist_bg,"noBackground":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }